/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
import { unmountComponentAtNode } from 'react-dom';
export default unmountComponentAtNode;
